import Vue from 'vue'
import router from '@/router'
import store from '@/store/index'
import ElementUI from 'element-ui';
//import elmToZv from './eleToZv'
import './components/global'
require('moment-precise-range-plugin')
import api from '@/api/baseApi'
import lodash from '@/utils/tools/lodash'
import commonFunc from '@/utils/tools/common'
import '@/utils/filters'
import LoadingPlugin from '@/utils/plugins/loading_plugin'
import HttpPlugin from "@/utils/plugins/http_plugin"
import HttpService from "@/utils/plugins/http_service_plugin"
import enums from '@/utils/enums'
import md5 from 'js-md5'

import "normalize.css"
import "@/static/css/nprogress.css"
import "@/static/less/reset.less"
import "@/static/less/common.less"
import "@/static/sass/element-variables.scss"
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


import App from './App.vue'
import timestamps from 'vue-timestamp-to'
Vue.use(timestamps)
// 关闭生产环境的调试信息
const isDebug_mode = process.env.NODE_ENV !== 'production'
Vue.config.debug = isDebug_mode;
Vue.config.devtools = isDebug_mode;
Vue.config.productionTip = isDebug_mode;
Vue.prototype.$_ = lodash
Vue.prototype.$api = api
Vue.prototype.$enums = enums
Vue.prototype.$commFunc = commonFunc
Vue.prototype.$md5 = md5

// simulation data
if (process.env.VUE_APP_NODE_ENV === 'mock') {
    require('./mock') // simulation data
}

// 日期转换函数
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2017-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2017-7-2 8:9:4.18
window.Date.prototype.$Format = function (fmt) {
    let o = {
        'M+': this.getMonth() + 1,                    // 月份
        'd+': this.getDate(),                         // 日
        'h+': this.getHours(),                        // 小时
        'm+': this.getMinutes(),                      // 分
        's+': this.getSeconds(),                      // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3),  // 季度
        'S': this.getMilliseconds()                   // 毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (`${this.getFullYear()}`).substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
        }
    }
    return fmt
}

Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
//Vue.use(elmToZv);
Vue.use(LoadingPlugin);
Vue.use(HttpPlugin);
Vue.use(HttpService);
Vue.use(VueQuillEditor)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
